/**
 * `core/wordpress/mwwpform/recaptcha.js`
 * - Google reCAPTCHA の処理
 *
 * 使用方法:
 * - import {initReCAPTCHA, loadReCaptcha} from "../mwwpform/index.js";
 */


import {config} from "../../../config.js";
import {barbaEventObserver} from "../../barba/utils/barbaEventObserver.js";


/**
 * initReCAPTCHA
 * - Google reCAPTCHAの初期化
 * - デフォルトの仕様: 2分制限 の解除
 */
export function initReCAPTCHA() {
  console.log("🔑 Initializing reCAPTCHA...");

  const mwWpFormSubmit = document.querySelector('.mw_wp_form [type="submit"][name="submitConfirm"]');
  if (!mwWpFormSubmit) return;

  mwWpFormSubmit.addEventListener('click', sendReCAPTCHA);
  barbaEventObserver.observeEvents([[mwWpFormSubmit, 'click', sendReCAPTCHA]]);
}


/**
 * sendReCAPTCHA
 * - reCAPTCHA の送信処理
 * - initReCAPTCHAで実行
 */
function sendReCAPTCHA(e) {
  e.preventDefault();
  const form = document.querySelector('.mw_wp_form > form');
  const submitBtn = document.querySelector('.mw_wp_form [type="submit"][name="submitConfirm"]');
  submitBtn.disabled = true;

  grecaptcha.ready(() => {  // eslint-disable-line no-undef
    grecaptcha.execute(config.recaptchaPublicKey, {action: "submit"}).then((token) => { // eslint-disable-line no-undef
      fetch("/wp/wp-admin/admin-ajax.php", {
        method: "POST",
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        body: new URLSearchParams({"action": "verify_recaptcha", "token": token}),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            const hiddenField = document.createElement("input");
            hiddenField.type = "hidden";
            hiddenField.name = "submitConfirm";
            hiddenField.value = "確認画面へ";
            form.appendChild(hiddenField);
            form.submit();
          } else {
            alert("reCAPTCHA verification failed. Please try again.");
            submitBtn.disabled = false;
          }
        })
        .catch((err) => {
          console.error("Error:", err);
          submitBtn.disabled = false;
        });
    });
  });
}


/**
 * loadReCaptcha
 * Google reCAPTCHAスクリプトの動的読み込み
 **/
export function loadReCaptcha() {
  const siteKey = config.recaptchaPublicKey;
  if (document.getElementById("recaptcha-script-js")) return;

  const script = document.createElement("script");
  script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
  script.id = "recaptcha-script-js";
  document.body.appendChild(script);

  /*
    // initReCAPTCHAで代用できるので削除
    script.onload = () => {
      grecaptcha.ready(() => {  // eslint-disable-line no-undef
        grecaptcha.execute(siteKey, {action: "homepage"}).then((token) => {  // eslint-disable-line no-undef
          const recaptchaResponse = document.querySelector('input[name="recaptcha-v3"]');
          if (recaptchaResponse) recaptchaResponse.value = token;
        });
      });
    };
  */
}